/**
 * External dependencies
 */
import classnames from 'classnames';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper/core';

/**
 * WordPress dependencies.
 */
import { useEffect, useState } from '@wordpress/element';
import { withDispatch, useSelect } from '@wordpress/data';
import { InnerBlocks, store as blockEditorStore } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { compose } from '@wordpress/compose';
import { Placeholder } from '@wordpress/components';

/**
 * Internal dependencies
 */
import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
import { GalleryCarouselIcon as icon } from '../../components/Icons';
import BlockAppenderButton from '../../components/BlockAppenderButton';

// install Swiper modules
SwiperCore.use( [ Pagination, Navigation, Autoplay ] );

const Edit = ( props ) => {
	const { isSelected, className, clientId, attributes } = props;
	const { blockClientId, blockAdvanceOptions } = attributes;
	const { layout = 'layout-1' } = blockAdvanceOptions;
	const [ { isEditing }, setState ] = useState( {
		isEditing: false,
	} );

	const { hasInnerBlocks } = useSelect(
		( select ) => {
			const { getBlock } = select( blockEditorStore );
			const block = getBlock( clientId );
			return {
				hasInnerBlocks: !! ( block && block.innerBlocks.length ),
			};
		},
		[ clientId ]
	);

	useEffect( () => {
		setState( {
			isEditing: ! hasInnerBlocks,
		} );
	}, [] );

	const wrapperClasses = classnames(
		className,
		`gutenify-section-${ blockClientId }`,
		`gutenify-section-${ layout }`,
	);

	const toggleEditSlidesMode = () => {
		setState( {
			isEditing: ! isEditing,
		} );
	};

	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } toggleEditSlidesMode={ toggleEditSlidesMode } isEditing={ isEditing } /> }
		<BaseWrapper { ...props }>
			<div>
				{ ( ! isEditing ) && <><Placeholder icon={ icon }
					label={ __( 'Slider' ) }>
					<img src={ `${ window.gutenify_block_data.plugin_directory_url }/assets/images/slider/slider-preview.png` } alt="Slider preview" />
				</Placeholder> </> }
				{ <>
					<Placeholder icon={ icon }
						label={ __( 'Edit Slides' ) } style={ { display: isEditing ? '' : 'none' } }>
						<div className="gutenify-slider-edit-wrapper">
							<InnerBlocks
								allowedBlocks={ [ 'gutenify/slide-item' ] }
								renderAppender={ () => {
									return <BlockAppenderButton { ...props } label={ __( '+ Add Slide' ) } />;
								} }
							/>

						</div>
					</Placeholder>
				</> }
			</div>
		</BaseWrapper>
	</div>;
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { selectBlock } = dispatch( 'core/block-editor' );

		return {
			selectBlock: () => {
				selectBlock( props.clientId );
			},
		};
	} ),
] )( Edit );
